
<template>
  <v-form v-model="valid">
    <v-text-field
      v-model="password"
      :name="password"
      :rules="[rules.required, rules.noSoloEspacios, rules.min(8), rules.max(20)]"
      :type="mostrarPassword ? 'text' : 'password'"
      :append-icon="!mostrarPassword ? 'visibility' : 'visibility_off'"
      @click:append="mostrarPassword = !mostrarPassword"
      :label="$t('pages.login.nuevaContrasena')"
      required
    />
    <v-text-field
      v-model="passwordRepetida"
      :name="passwordRepetida"
      :rules="[rules.required, rules.noSoloEspacios, passwordRepetidaRules, rules.min(8), rules.max(20)]"
      :type="mostrarPasswordRepetir ? 'text' : 'password'"
      :append-icon="!mostrarPasswordRepetir ? 'visibility' : 'visibility_off'"
      @click:append="mostrarPasswordRepetir = !mostrarPasswordRepetir"
      :label="$t('pages.login.repetirContrasena')" 
      required
    />
    <v-text-field
      v-if="!conPasswordUsoUnico"
      v-model="passwordActual"
      :name="passwordActual"
      :rules="[rules.required, rules.noSoloEspacios, rules.max(20)]"
      :type="mostrarPasswordActual ? 'text' : 'password'"
      :append-icon="!mostrarPasswordActual ? 'visibility' : 'visibility_off'"
      @click:append="mostrarPasswordActual = !mostrarPasswordActual"
      :label="$t('pages.login.passwordActual')" 
      :required="!conPasswordUsoUnico"
    />
    <v-layout justify-center mt-3>
      <v-btn :disabled="!valid || desactivarBoton" :loading="desactivarBoton" color="primary" @click="modificarPassword()">
        {{$t('pages.login.modificar')}}
      </v-btn>
    </v-layout>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex'
import rulesMixin from '@/mixins/rules.js'
export default {
  mixins: [rulesMixin],
  props: {
    conPasswordUsoUnico: {
      default: false
    }
  },
  data () {
    return {
      mostrarPassword: false,
      mostrarPasswordRepetir: false,
      mostrarPasswordActual: false,
      password: '',
      passwordRepetida: '',
      passwordActual: '',
      valid: false,
      desactivarBoton: false
    }
  },
  methods: {
    ...mapActions({
      modificarPasswordApi: 'login/modificarPassword',
      modificarPasswordUsoUnicoApi: 'login/modificarPasswordUsoUnico',
      addAlert: 'alerts/add'
    }),
    passwordRepetidaRules (v) {
      return v === this.password || this.$t('pages.login.noCoinciden')
    },
    async modificarPassword () {
      this.desactivarBoton = true
      try {
        if (this.conPasswordUsoUnico) {
          await this.modificarPasswordUsoUnicoApi({
            password: this.password,
            passwordRepetida: this.passwordRepetida
          })
        } else {
          await this.modificarPasswordApi({
            password: this.password,
            passwordRepetida: this.passwordRepetida,
            passwordActual: this.passwordActual
          })
        }
        this.addAlert({texto: this.$t('pages.login.modificadoExito'), color: 'success'})
        this.$emit('passwordModificada')
        this.desactivarBoton = false
      } catch (error) {
        this.desactivarBoton = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/cambiarPassword/CambiarPassword.vue